<template>
    <div style="background: #F5F6F7;">
        <div class="home-container">
            <div class="logo-container" :class="{ 'white-bg': showProductList }">
                <div class="logo-wrapper">
                    <img src="../assets/logo.png" alt="" class="logo">
                </div>
                <div class="hamburger" @click="toggleMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="nav-links desktop-only">
                    <div class="nav-item" @click="$router.push('/')">首页</div>
                    <div class="nav-item" :class="{ 'active-product': showProductList }" @click="handleProductClick">
                        雾曼技术和产品
                    </div>
                    <div class="nav-item nav-item2" @click="$router.push('/Dynamic'), FisMobile()">雾曼动态</div>
                    <div class="nav-item" @click="$router.push('/about')">关于雾曼</div>
                    <div class="nav-item" @click="$router.push('/contact')">联系雾曼</div>
                    <div class="nav-item" @click="$router.push('/Cooperation')">成为合伙人</div>
                    <!-- <div class="nav-item  nav-item2">成为合伙人</div> -->

                </div>
                <div class="consult-button" @click="navigateToConsult">需求咨询</div>


                <div class="mobile-menu" :class="{ 'active': isMenuOpen }">
                    <div class="nav-item" @click="handleMobileNav('/')">首页</div>
                    <!-- <div class="nav-item" @click="handleMobileNav('/product')">雾曼技术和产品</div> -->
                    <div class="nav-item" @click="handleMobileNav('/Dynamic')">雾曼动态</div>
                    <div class="nav-item" @click="handleMobileNav('/about')">关于雾曼</div>
                    <div class="nav-item" @click="handleMobileNav('/contact')">联系雾曼</div>
                    <div class="nav-item" @click="handleMobileNav('/Cooperation')">成为合伙人</div>
                    <div class="mobile-consult-button" @click="navigateToConsult">需求咨询</div>
                </div>
            </div>
            <product-list v-if="showProductList" :top="0" />
            <div class="info-container" v-if="!showProductList">
                <div style="color: #FFFFFF;font-size: 52px;font-weight: 500;margin: 96px 0 0 213px;">雾曼动态</div>

            </div>
        </div>
        <div style="width: 1352px;margin: 55px auto; min-height:1000px">
            <div v-for="item in newsItems" :key="item.contentId" class="news-item" @click="goToDetail(item.contentId)"
                style="margin: 0 auto 20px;background: #fff;border-radius: 15px;padding: 25px;display: flex;">
                <div style="width: 353px;height: 246px;flex-shrink: 0;">
                    <img style="width: 353px;height: 246px;object-fit: cover;" :src="item.image" alt="">
                </div>
                <div style="padding: 0 0 0 30px;flex: 1;">
                    <div style="font-size: 30px;color: rgba(0,0,0,0.85);font-weight: 500;">
                        {{ item.title }}
                    </div>
                    <div style="font-weight: 400;font-size: 20px;color: rgba(0,0,0,0.5);margin: 7px 0 0 0;">
                        {{ item.desc }}
                    </div>
                    <div style="font-weight: 400;font-size: 20px;color: rgba(0,0,0,0.5);margin: 47px 0 0 0;">
                        {{ formatDate(item.createTime) }}
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->
        <Footer />

    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import ProductList from '@/components/ProductList.vue'
import ChatWidget from '@/components/ChatWidget.vue'

export default {
    name: 'HomeHeader',
    components: {
        Footer,
        ProductList,
        ChatWidget
    },
    data() {
        return {
            newsItems: [],
            isMenuOpen: false,
            showProductList: false,
            isOpen: false
        }
    },
    methods: {
        getNews() {
            this.$http.get('/cms/content/front-list?pageNum=1&pageSize=10&catalogId=636460636414021').then(res => {
                if (res.code === 200 && res.data.rows) {
                    this.newsItems = res.data.rows.map(item => ({
                        image: item.logoSrc || require('../assets/home5.png'),
                        title: item.title,
                        desc: item.subTitle || '暂无描述',
                        contentId: item.contentId,
                        createTime: item.createTime
                    }));
                } else {
                    throw new Error('获取数据失败');
                }
            }).catch(error => {
                console.error('获取新闻列表失败:', error);
                this.newsItems = [
                    {
                        image: require('../assets/home5.png'),
                        title: '雾曼入选2024年度农业"火花技术"成果库',
                        desc: '近日，农业农村部科学技术司公布了2024年度…',
                        createTime: '2024-10-12 12:12:31'
                    }
                    // ... 可以添加更多默认数据
                ]
            });
        },
        FisMobile() {
            this.showProductList = false;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
        },
        goToDetail(contentId) {
            this.$router.push(`/news/detail?id=${contentId}`);
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        handleMobileNav(path) {
            this.isMenuOpen = false;  // 关闭移动端菜单
            this.$router.push(path);
        },
        handleProductClick() {
            this.showProductList = !this.showProductList;

        },
        navigateToConsult() {
            this.$router.push('/contact').then(() => {
                setTimeout(() => {
                    window.scrollTo({
                        top: 1000,
                        behavior: 'smooth'
                    });
                }, 500);
            });
        },
        openChat() {
            console.log(this.isOpen)
            this.isOpen = !this.isOpen
        }
    },
    created() {
        this.getNews();
    },

}
</script>

<style scoped>
.home-container {
    width: 100%;
    height: 380px;
    background-color: #000;
    background-image: url("../assets/coop/coop1.png");
    background-size: cover;
    background-position: center;
}

.logo-container {
    width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(3px);
    padding: 0 55px;
    display: flex;
    align-items: center;
    position: relative;
}

.logo-wrapper {
    position: absolute;
}

.logo {
    width: 251px;
    height: 32px;
}

.nav-links {
    display: flex;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    margin: auto;
    height: 68px;
    line-height: 70px;
    cursor: pointer;
}

.nav-item {
    padding: 0 20px;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.consult-button {
    background: #FFFFFF;
    border-radius: 17px;
    width: 96px;
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    color: #0A2E43;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 54px;
}

/* .info-container {
    width: 1120px;
    margin: auto;
    margin: 233px;
} */

.info-box {
    width: calc(367px - 13px - 13px);
    padding: 0 13px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 8px;
    line-height: 48px;
}

.info-title {
    font-size: 20px;
    color: #041214;
    font-weight: 500;
    font-style: normal;
}

.info-subtitle {
    color: #041214;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
}

.info-text {
    font-weight: 500;
    font-size: 56px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    width: 1120px;
}

.contact-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.contact-label {
    color: #FFFFFF;
    font-size: 14px;
    margin-left: 8px;
}

.contact-button {
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    height: 48px;
    width: 158px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.contact-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.contact-button img {
    width: 16px;
    height: 16px;
}

.contact-text,
.contact-icon {
    display: none;
}

.news-item {
    cursor: pointer;
    transition: all 0.3s ease;
}

.news-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
    .home-container {
        height: 250px;
    }

    .logo-container {
        height: 50px;
        padding: 0 15px;
    }

    .logo {
        width: 150px;
        height: 20px;
    }

    .desktop-only {
        display: none;
    }

    .hamburger {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 25px;
        height: 20px;
        position: absolute;
        right: 15px;
        cursor: pointer;
        z-index: 1001;
    }

    .hamburger span {
        display: block;
        width: 100%;
        height: 2px;
        background-color: #fff;
        transition: all 0.3s ease;
    }

    .mobile-menu {
        display: none;
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.3s ease;
        height: calc(100vh - 50px);
    }

    .mobile-menu.active {
        display: block;
        opacity: 1;
    }

    .mobile-menu .nav-item {
        padding: 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        color: #fff;
        font-size: 16px;
    }

    .mobile-consult-button {
        margin: 20px auto;
        background: #FFFFFF;
        border-radius: 17px;
        width: 90%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #0A2E43;
        font-weight: 600;
    }

    .info-container div {
        font-size: 32px !important;
        margin: 60px 0 0 20px !important;
    }

    /* 新闻列表适配 */
    div[style*="width: 1352px"] {
        width: 100% !important;
        padding: 0 15px;
        box-sizing: border-box;
    }

    .news-item {
        flex-direction: column;
        padding: 15px !important;
    }

    .news-item>div:first-child {
        width: 100% !important;
        height: auto !important;
        margin-bottom: 15px;
    }

    .news-item img {
        width: 100% !important;
        height: 200px !important;
    }

    .news-item>div:last-child {
        padding: 0 !important;
    }

    .news-item>div:last-child>div:first-child {
        font-size: 20px !important;
    }

    .news-item>div:last-child>div:nth-child(2) {
        font-size: 16px !important;
    }

    .news-item>div:last-child>div:last-child {
        font-size: 14px !important;
        margin-top: 20px !important;
    }

    .nav-links,
    .consult-button {
        display: none;
    }
}

/* 确保在大屏幕下隐藏移动端元素 */
@media screen and (min-width: 769px) {

    .hamburger,
    .mobile-menu {
        display: none;
    }
}

.white-bg {
    background: #FFFFFF !important;
}

.white-bg .nav-links .nav-item {
    color: #0A2E43;
}

.active-product {
    color: #FF0000 !important;
    border-bottom: 2px solid #FF0000 !important;
}
</style>